import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CiudadPage",
    data() {
        let ss = new MainService();
        return {
            msg: "CiudadPage",
            ss: ss,
            ajax: {
                "url": ss.indexCiudad(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Pais', name: 'p.Pais', title: 'País' },
                { data: 'Ciudad', name: 'c.Ciudad', title: 'Ciudad' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            ciudads: [],
            paiss: [],
            ciudad: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newCiudad() {
            this.ciudad = {};
            this.$refs['frm-ciudad'].show();
        },
        showCiudad(id) {
            this.isLoading=true;
            this.ss.showCiudad(id).then(
                (result) => {
                    let response = result.data;
                    this.ciudad = response.data;
                    this.$refs['view-ciudad'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        getPais() {
            this.ss.listPais().then(
                (result) => {
                    let response = result.data;
                    this.paiss = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        editCiudad() {
            this.$refs['frm-ciudad'].show();
            this.$refs['view-ciudad'].hide();
        },
        cancelCiudad() {
            if (this.ciudad.id) {
                this.$refs['view-ciudad'].show();
            }
            this.$refs['frm-ciudad'].hide();
        },
        saveCiudad() {
            this.ss.storeCiudad(this.ciudad).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-ciudad'].hide();
                    this.$refs['datatable-ciudad'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteCiudad() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyCiudad(this.ciudad)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-ciudad'].hide();
                                this.$refs['datatable-ciudad'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Ciudad').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showCiudad(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }else{
            this.getPais();
        }
    }
};
